"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var single_1 = require("utils/selectors/single");
var CompanyBrandWrapper_1 = require("./styles/CompanyBrandWrapper");
var CompanyInfo = function () {
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    if (!company) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(CompanyBrandWrapper_1.CompanyBrandWrapper, __assign({ to: "/" }, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, { brand: company, fullWidth: true }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, ml: 1, noWrap: true }, { children: (company === null || company === void 0 ? void 0 : company.name) || '' }))] })));
};
exports.default = CompanyInfo;
